import { Client } from "./_clientService";

async function getChallengeRewardImages() {
  try {
    const resp = await new Client({
      path: "/challenge-reward-images/list",
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function getChallengeRewardImageInfo(challengeRewardImageId: any) {
  try {
    const resp = await new Client({
      path: "/challenge-reward-images/info",
      payload: { challengeRewardImageId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function createChallengeRewardImage(details: any) {
  try {
    const resp = await new Client({
      path: "/challenge-reward-images/create",
      payload: details,
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function updateChallengeRewardImage(details: any, id: any) {
  try {
    const resp = await new Client({
      path: "/challenge-reward-images/update",
      payload: { ...details, _id: id },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function deleteChallengeRewardImage(challengeRewardImageId: any) {
  try {
    const resp = await new Client({
      path: "/challenge-reward-images/delete",
      payload: { challengeRewardImageId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export {
  getChallengeRewardImages,
  getChallengeRewardImageInfo,
  createChallengeRewardImage,
  updateChallengeRewardImage,
  deleteChallengeRewardImage,
};
